import { Coupon, Gift } from '../types';

export default class GiftsState {
  gifts: Gift[] = [];
  coupons: Coupon[] = [];
  items: string[] = [];
}
